import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=815bc058&"
import script from "./QuestionList.vue?vue&type=script&lang=ts&"
export * from "./QuestionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('815bc058')) {
      api.createRecord('815bc058', component.options)
    } else {
      api.reload('815bc058', component.options)
    }
    module.hot.accept("./QuestionList.vue?vue&type=template&id=815bc058&", function () {
      api.rerender('815bc058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuestionList.vue"
export default component.exports